const KINDS = {
  funcional: { label: "Disponible", cls: "border-brand-pos/40 text-brand-pos bg-brand-pos/[0.12]" },
  demo: { label: "Demostración", cls: "border-brand-gold/40 text-brand-goldSoft bg-brand-gold/[0.12]" },
  proximamente: { label: "Próximamente", cls: "border-brand-line text-brand-muted bg-brand-panel2" },
};

export function Tag({ kind = "demo", className = "" }) {
  const k = KINDS[kind] || KINDS.demo;
  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${k.cls} ${className}`}>
      {k.label}
    </span>
  );
}
